import React, { PropsWithChildren } from 'react';

import { DisplayModal } from './display-modal';

interface ModalProps {
  isOpen: boolean;
  showBackdrop?: boolean;
  closable?: boolean;
  handleClose: () => void;
}

export const Modal = ({
  isOpen,
  showBackdrop = true,
  closable = true,
  children,
  handleClose,
}: PropsWithChildren<ModalProps>) => {
  if (!isOpen) return null;

  return (
    <DisplayModal
      closable={closable}
      handleClose={handleClose}
      showBackdrop={showBackdrop}
    >
      {children}
    </DisplayModal>
  );
};
